import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { ApplicantForm } from '../../forms/applicant.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../openapi';

@Component({
  selector: 'app-company-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective
  ],
  templateUrl: './company-form.component.html'
})
export class CompanyFormComponent implements OnInit {

  private entityType = '8172a696-2a3b-402a-b262-dfcf37404da3';

  @Input()
  public form: ApplicantForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  constructor() {
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.entityType });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.entityType });
  }

  public ngOnInit(): void {
    this?.form?.applicantType.setValue(this.entityType);

    this.form?.name.enable();
    this.form?.nip.enable();

    this.form?.firstName.disable();
    this.form?.lastName.disable();
  }
}
